import React, { useState, useCallback } from 'react';
import Shell from './Shell';
import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Stable callback refs — MUST NOT recreate on every render.
  // If onClose is a new function reference on each render, Shell's useEffect
  // (which depends on handleClose ← onClose) fires immediately after open,
  // calling setMobileOpen(false) and snapping the menu closed again.
  const handleClose  = useCallback(() => setMobileOpen(false), []);
  const handleToggle = useCallback(() => setMobileOpen(prev => !prev), []);

  return (
    <div className="relative min-w-[300px]">
      <Shell mobileOpen={mobileOpen} onClose={handleClose} />
      <Header onMenuToggle={handleToggle} mobileOpen={mobileOpen} />
      {/* Spacer to offset fixed header height */}
      <div className="h-[74px]" aria-hidden="true" />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
